export const LOAD_USER_CALCULS = "LOAD_USER_CALCULS";
export const GET_USER_CALCULS_SUCCESS = "GET_USER_CALCULS_SUCCESS";
export const GET_USER_CALCULS_FAILED = "GET_USER_CALCULS_FAILED";
export const CHANGE_CALCULS_SORT = "CHANGE_CALCULS_SORT";
export const CHANGE_CALCULS_PAGE = "CHANGE_CALCULS_PAGE";
export const CHANGE_CALCULS_SEARCH = "CHANGE_CALCULS_SEARCH";
export const DELETE_CALCUL = "DELETE_CALCUL";
export const DELETE_CALCUL_SUCCESS = "DELETE_CALCUL_SUCCESS";
export const DELETE_CALCUL_FAILED = "DELETE_CALCUL_FAILED";
export const DUPLICATE_CALCUL = "DUPLICATE_CALCUL";
export const DUPLICATE_CALCUL_SUCCESS = "DUPLICATE_CALCUL_SUCCESS";
export const GET_CALCUL_SUCCESS = "GET_CALCUL_SUCCESS";
export const LOAD_CALCUL = "LOAD_CALCUL";
export const LOAD_CALCUL_FAILED = "LOAD_CALCUL_FAILED";
export const UPGRADE_CALCUL_SUCCESS = "UPGRADE_CALCUL_SUCCESS";
export const CLEAR_CALCUL = "CLEAR_CALCUL";
export const CLEAR_CALCUL_OBJECT = "CLEAR_CALCUL_OBJECT";
export const LOAD_CALCUL_SUCCESS = "LOAD_CALCUL_SUCCESS";
export const REMOVE_REPORTS = "REMOVE_REPORTS";
export const GET_ALL_USER_CALCULS = "GET_ALL_USER_CALCULS";
export const GET_ALL_USER_CALCULS_SUCCESS = "GET_ALL_USER_CALCULS_SUCCESS";
export const GET_ALL_USER_CALCULS_FAILED = "GET_ALL_USER_CALCULS_FAILED";
export const UPDATE_CALCULS_LIMIT = "UPDATE_CALCULS_LIMIT";
export const SET_CALCUL_ARCHIVED = "SET_CALCUL_ARCHIVED";
export const SET_CALCUL_ARCHIVED_SUCCESS = "SET_CALCUL_ARCHIVED_SUCCESS";
export const SET_CALCUL_ARCHIVED_FAILED = "SET_CALCUL_ARCHIVED_FAILED";
export const RESTORE_ARCHIVED_CALCUL = "RESTORE_ARCHIVED_CALCUL";
export const RESTORE_ARCHIVED_CALCUL_SUCCESS =
  "RESTORE_ARCHIVED_CALCUL_SUCCESS";
export const RESTORE_ARCHIVED_CALCUL_FAILED = "RESTORE_ARCHIVED_CALCUL_FAILED";
export const UPDATE_CALCUL_ATTRIBUTES = "UPDATE_CALCUL_ATTRIBUTES";
export const UPDATE_CALCUL_ATTRIBUTES_SUCCESS =
  "UPDATE_CALCUL_ATTRIBUTES_SUCCESS";
export const UPDATE_CALCUL_ATTRIBUTES_FAILED =
  "UPDATE_CALCUL_ATTRIBUTES_FAILED";
export const MANAGE_CALCULS_BULK = "MANAGE_CALCULS_BULK";
export const MANAGE_CALCULS_BULK_SUCCESS = "MANAGE_CALCULS_BULK_SUCCESS";
export const MANAGE_CALCULS_BULK_FAILED = "MANAGE_CALCULS_BULK_FAILED";
export const UPDATE_CALCULS_FILTERS = "UPDATE_CALCULS_FILTERS";
export const OPEN_CALCULS_FILTERS_SECTION = "OPEN_CALCULS_FILTERS_SECTION";
export const CLOSE_CALCULS_FILTERS_SECTION = "CLOSE_CALCULS_FILTERS_SECTION";

// CALCUL STATUSES
export const IN_PROGRESS = "IN_PROGRESS";
export const FINISHED = "FINISHED";

export const defaultCalculsFilters = {
  statuses: [],
  productFamilies: [],
  folders: [],
  updatedAt: {
    $gte: undefined,
    $lte: undefined,
  },
  result: {
    $gte: undefined,
    $lte: undefined,
  },
};
